// extracted by mini-css-extract-plugin
module.exports = {"zone-power":"ZonePower_zone-power__dIUex","power-opponent":"ZonePower_power-opponent__uD9wE","power-player":"ZonePower_power-player__T0rle","leader":"ZonePower_leader__Vo9FJ"};